"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  Text: true
};
exports.default = exports.Text = void 0;
var _bind = _interopRequireDefault(require("classnames/bind"));
var _reactMergeRefs = _interopRequireDefault(require("react-merge-refs"));
var _reactToString = _interopRequireDefault(require("react-to-string"));
var _react = _interopRequireWildcard(require("react"));
var _debounce = require("../utils/debounce");
var _useResizeObserver = require("../utils/useResizeObserver");
var _Button = require("../Buttons/Button");
var _useUniqueId = _interopRequireDefault(require("../utils/useUniqueId"));
var _Text = require("./Text.types");
Object.keys(_Text).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _Text[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Text[key];
    }
  });
});
var _Text2 = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Text.css") : void 0);
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
const CSS_BLOCK = 'sapcnqr-text';
/**
 * The **Text** component can be used for embedding long
 * text, that needs themed styles
 * and formatting and/or truncation,
 * into your application.
 */
const Text = exports.Text = /*#__PURE__*/_react.default.forwardRef((props, ref) => {
  const {
      allowHyphenation,
      children,
      className,
      expanded,
      id,
      maxLines,
      showMore,
      tag = 'span',
      useLabelStyles,
      subtitleStyles
    } = props,
    otherProps = __rest(props, ["allowHyphenation", "children", "className", "expanded", "id", "maxLines", "showMore", "tag", "useLabelStyles", "subtitleStyles"]);
  const [hasMaxLines, setHasMaxLines] = (0, _react.useState)(typeof maxLines === 'number' && maxLines > 0);
  const [isClamped, setIsClamped] = (0, _react.useState)(false);
  const [isExpanded, setIsExpanded] = (0, _react.useState)(!!expanded);
  const classnames = _bind.default.bind(_Text2.default);
  const textRef = (0, _react.useRef)(null);
  const mergedRef = (0, _reactMergeRefs.default)([ref, textRef]);
  const textId = (0, _useUniqueId.default)();
  const {
    showMoreLabel,
    showLessLabel,
    onClick: onShowMoreClick,
    buttonProps,
    containerProps
  } = showMore || {};
  const updateClamping = () => {
    const {
      offsetHeight,
      scrollHeight
    } = textRef.current || {};
    const newIsClamping = scrollHeight > offsetHeight;
    setIsClamped(newIsClamping);
  };
  const onResize = (0, _debounce.debounce)(() => {
    if (isExpanded) return;
    updateClamping();
  });
  (0, _useResizeObserver.useResizeObserver)({
    targetRef: textRef,
    onResize,
    skipStateUpdate: true
  });
  (0, _react.useEffect)(() => {
    if (!isExpanded) {
      updateClamping();
    }
  }, [isExpanded]);
  (0, _react.useEffect)(() => {
    const newValue = typeof maxLines === 'number' && maxLines > 0;
    setHasMaxLines(newValue);
  }, [maxLines]);
  let maxLineStyle;
  if (hasMaxLines && !isExpanded) {
    maxLineStyle = {
      // @ts-expect-error maxLines
      WebkitLineClamp: `${parseInt(maxLines, 10)}`
    };
  }
  const handleShowMoreClick = () => {
    const newIsExpanded = !isExpanded;
    setIsExpanded(newIsExpanded);
    onShowMoreClick === null || onShowMoreClick === void 0 ? void 0 : onShowMoreClick(newIsExpanded);
  };
  const classes = classnames(className, CSS_BLOCK, {
    [`${CSS_BLOCK}--max-lines`]: hasMaxLines,
    [`${CSS_BLOCK}--hyphenation`]: allowHyphenation,
    [`${CSS_BLOCK}--label`]: useLabelStyles,
    [`${CSS_BLOCK}--subtitle`]: subtitleStyles
  });
  const containerClasses = classnames(`${CSS_BLOCK}__container`, containerProps === null || containerProps === void 0 ? void 0 : containerProps.className);
  const ElementToRender = _Text.TEXT_TAGS.indexOf(tag) !== -1 ? tag : 'span';
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(ElementToRender, Object.assign({
    title: isClamped && !isExpanded ? (0, _reactToString.default)(children) : undefined
  }, otherProps, {
    id: hasMaxLines && showMore && !id ? textId : id,
    ref: mergedRef,
    className: classes,
    style: Object.assign(Object.assign({}, otherProps === null || otherProps === void 0 ? void 0 : otherProps.style), maxLineStyle)
  }), children), hasMaxLines && showMore && (isClamped || isExpanded) && (/*#__PURE__*/_react.default.createElement("div", Object.assign({}, containerProps, {
    className: containerClasses
  }), /*#__PURE__*/_react.default.createElement(_Button.Button, Object.assign({
    compact: true,
    type: "link"
  }, buttonProps, {
    "aria-controls": !id ? textId : id,
    "aria-expanded": isExpanded,
    onClick: handleShowMoreClick
  }), isExpanded ? showLessLabel : showMoreLabel))));
});
Text.displayName = 'Text';
var _default = exports.default = Text;